module.exports = __webpack_public_path__ + "img/defaultusercartoon.7a0b0259.png";